import React from 'react';
import FolktalesCharacters from 'assets/img/folktales_characters2.png';


const Description = () => {
    return (
        <div className="flex flex-col md:flex-row items-center justify-between md:px-44 px-6 py-20 bg-primary-50">
            <div className="md:w-1/2 pr-8">
                <p className="text-md text-sage-600 font-semibold mb-2 tracking-wide uppercase">Practica tu japonés leyendo</p>
                <h1 className="text-4xl md:text-5xl font-bold mb-6 text-japanese-ink font-japanese leading-tight">
                    Cuentos tradicionales
                </h1>
                <p className="text-lg text-charcoal-600 leading-relaxed mb-6">
                    Descubre Japón a través de historias clásicas. 
                    <br />
                    <span className="text-primary-600 font-semibold">¡Momotaro, Kintaro y muchos más personajes</span> te esperan para acompañarte en tu aprendizaje!
                </p>
                <div className="flex space-x-4">
                    <div className="bg-sage-100 p-4 rounded-xl border-l-4 border-sage-500">
                        <p className="text-sm font-semibold text-sage-700">🎌 Cultura auténtica</p>
                    </div>
                    <div className="bg-japanese-paper p-4 rounded-xl border-l-4 border-primary-500">
                        <p className="text-sm font-semibold text-primary-700">📚 Aprendizaje divertido</p>
                    </div>
                </div>
            </div>
            <div className="md:w-1/2 mt-8 md:mt-0">
                <img src={FolktalesCharacters} alt="Description" className="w-full h-auto rounded-2xl shadow-xl" draggable="false" />
            </div>
        </div>
    );
};

export default Description;